import {
  apiRequest, postApiRequest,
} from './_tools';

export function login({ email, password }) {
  return postApiRequest(`/api/auth/login${window.location.search}`, { email, password })
    .catch(({ error }) => Promise.reject(error));
}

export function getUser(role) {
  return apiRequest(`/api/auth/user?role=${role}`)
    .catch(({ error }) => Promise.reject(error));
}

export function resetPassword(newPassword) {
  return postApiRequest('/api/auth/resetPassword', { newPassword })
    .catch(({ error }) => Promise.reject(error));
}

export function forgotPassword(email) {
  return postApiRequest('/api/auth/forgotPassword', { email })
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/auth.js
 **/